module.exports = __webpack_public_path__ + "img/petra-p.02e50d7b.svg";